import React, {useEffect, useState} from "react";
import {PATH} from "../../config";
import {Link, NavLink} from "react-router-dom";
import {Button, Col, Row} from "antd";
import {ROUTES as ROUTES_CONFIG, ROUTES} from "../../config/constants";

const HomePage = () => {

    const [opSysName, setOpSysName] = useState('');

    const operSys = () => {
        let os = navigator.userAgent;
        if (os.search('Windows')!==-1){
            setOpSysName('Windows')
        }
        else if (os.search('Mac')!==-1){
            setOpSysName('MacOS')
        }
    }

    useEffect(() => {
        operSys();
    }, [])


    return (
        <>
            <div className="video-layout">
                <div className="video-gradient"></div>
                <video loop autoPlay muted className="video-bg" src={PATH + 'video/site_cover_2.mp4'} />
                <div className="container mx-auto px-12 relative pt-162 py-8">
                    <div className="flex flex-col video-content">
                        <h2 className="font-mont font-bold mb-0 text-white video-content-title">Join the Social Metaverse</h2>
                        <p className="font-mont font-normal mb-0 video-content-desc">Build a vibrant Metaverse community and explore a myriad of immersive experiences.
                            Participate in exciting events, indulge in endless fun, and earn exclusive rewards.
                        </p>
                        {/*<a target="_blank" href={opSysName == 'MacOS' ? '' : 'https://dcdn.metafluence.com/mvp/mls-1.3.9.exe'}>*/}
                        {/*    <Button className="border-0 rounded-10px font-bold font-mont flex items-center justify-center video-content-btn">*/}
                        {/*        <img src={PATH + (opSysName == 'MacOS' ? 'mac' : 'windows' + '.svg')} alt=""/>*/}
                        {/*        <span>Download for {opSysName}</span>*/}
                        {/*    </Button>*/}
                        {/*</a>*/}
                        {opSysName == 'MacOS' ?
                            <a target="_blank" href={'https://app.metafluence.com/launcher/mac/'} className="video-btn-link">
                                <Button className="border-0 rounded-10px font-bold font-mont flex items-center justify-center video-content-btn">
                                    <img src={PATH + 'mac.svg'} alt=""/>
                                    <span>Download for Mac</span>
                                </Button>
                            </a>
                            // <div className="os-btn">
                            //     <Button className="border-0 rounded-10px font-bold font-mont flex items-center justify-center video-content-btn">
                            //         <img src={PATH + 'mac.svg'} alt=""/>
                            //         <span>Download for Mac</span>
                            //     </Button>
                            //     <span>Mac version will be active soon</span>
                            // </div>
                            :
                            <a target="_blank" href={'https://app.metafluence.com/launcher/windows/'} className="video-btn-link">
                                <Button className="border-0 rounded-10px font-bold font-mont flex items-center justify-center video-content-btn">
                                    <img src={PATH + 'windows.svg'} alt=""/>
                                    <span>Download for Windows</span>
                                </Button>
                            </a>
                        }
                    </div>
                </div>
            </div>
            <div className="container mx-auto px-12 py-8">
                <div className="join-layout mt-20">
                    <div className="flex flex-col items-center mx-auto join-header">
                        <h2 className="font-mont mb-0 font-bold text-white text-center join-header-title">Step into the captivating realm</h2>
                        <p className="font-mont mb-0 font-normal text-center join-header-desc">Join today to unlock a world of endless possibilities, where community thrives, and unforgettable experiences await.
                            Come, be a part of something extraordinary.
                        </p>
                    </div>

                    <Row gutter={{lg: 70}} className="join-steps mt-20">
                        <Col xs={24} sm={8} md={8} lg={8}>
                            <div className="flex flex-col items-center relative join-box" style={{background: `url(${PATH + 'land-box-bg.png'}) no-repeat center center / cover`}}>
                                <div className="join-box-bg"></div>
                                <h3 className="mb-0 text-white font-mont font-bold join-box-title">Land</h3>
                                <p className="font-mont font-normal mb-0 text-center join-box-desc">Secure a spot in a top city location in Metafluence</p>
                                <NavLink to={ROUTES_CONFIG.getDirectLand.path} className="join-box-link">
                                    <Button className="border-0 bg-white text-indigo-900 rounded-10px uppercase font-bold font-mont join-box-btn">
                                        Acquire
                                    </Button>
                                </NavLink>
                            </div>
                        </Col>
                        <Col xs={24} sm={8} md={8} lg={8}>
                            <div className="flex flex-col items-center join-box" style={{background: `url(${PATH + 'metahut-box-bg.png'}) no-repeat center center / cover`}}>
                                <div className="join-box-bg"></div>
                                <h3 className="mb-0 text-white font-mont font-bold join-box-title">Metahut</h3>
                                <p className="font-mont font-normal mb-0 text-center join-box-desc">Empowers you to unleash your creativity and express yourself in new and imaginative ways</p>
                                <NavLink to={ROUTES_CONFIG.getMetahut.path} className="join-box-link">
                                    <Button className="border-0 bg-white text-indigo-900 rounded-10px uppercase font-bold font-mont join-box-btn">
                                        CREATE
                                    </Button>
                                </NavLink>
                            </div>
                        </Col>
                        <Col xs={24} sm={8} md={8} lg={8}>
                            <div className="flex flex-col items-center join-box" style={{background: `url(${PATH + 'experience-box-bg.png'}) no-repeat center center / cover`}}>
                                <div className="join-box-bg"></div>
                                <h3 className="mb-0 text-white font-mont font-bold join-box-title">Experience</h3>
                                <p className="font-mont font-normal mb-0 text-center join-box-desc">Inviting individuals to explore, connect, and create like never before</p>
                                <NavLink to={ROUTES_CONFIG.loginPage.path} className="join-box-link">
                                    <Button className="border-0 bg-white text-indigo-900 rounded-10px uppercase font-bold font-mont join-box-btn">
                                        JOIN
                                    </Button>
                                </NavLink>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    )
}

export default HomePage;